import { render, staticRenderFns } from "./cardChart.vue?vue&type=template&id=531a7d29&scoped=true&"
import script from "./cardChart.vue?vue&type=script&lang=js&"
export * from "./cardChart.vue?vue&type=script&lang=js&"
import style0 from "./cardChart.vue?vue&type=style&index=0&id=531a7d29&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531a7d29",
  null
  
)

export default component.exports